module.exports = __webpack_public_path__ + "lc_monogram.cee7a6355ef6d14ab50d9574457f4527.png";